import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  isUndefined,
  onlyAphaNumeric,
  spaceToHyphen,
  toBoolean,
} from "src/app/services/codeUtils";
import { ConfigService } from "src/app/services/config/config.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { WebcontentService } from "src/app/services/webcontent/webcontent.service";
import { Navigator } from "../../menu/navigator";
import { GamesService } from "src/app/services/lobby/games.service";
import { ScrollService } from "src/app/services/scroll/scroll.service";
import { LobbyStateService } from "src/app/services/lobbyState/lobby-state.service";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { EventsService } from "src/app/services/event/event.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-gallery-casino",
  templateUrl: "./gallery-casino.component.html",
  styleUrls: ["./gallery-casino.component.scss"],
})
export class GalleryCasinoComponent implements OnInit, OnDestroy {
  @Input() showLastPlayed: boolean;
  @Input() customerLevel: number;
  @Input() isMobileWeb: boolean;
  @Input() LastPlayedGamesPresent: boolean;
  @Input() isMobileApp: boolean;

  public isAuthenticated: boolean;
  public isDemoEnabled: boolean;
  public pageSizeSet = 25;
  public mobileGamesSize = 20;
  public pageSize: number = this.pageSizeSet;
  public imagesPath: string;
  public isfavourite = false;
  public filteredCasinoGames: Array<any> = [];
  public mobileCasinoGames: any = null;
  public selectedItem: string;
  public allGamesLoaded = false;
  public mobileGameCounter = 1;
  public showLDInFavTab: boolean = false;
  private subscr: Array<Subscription> = [];

  public isTop: boolean = this.config.getConfig().FEATURE_JACKPOT_POSITION_TOP == "1" ? true : false;

  constructor(
    public webcontentService: WebcontentService,
    private config: ConfigService,
    private userSessionService: UserSessionService,
    private gameHubControllerService: GameHubControllerService,
    private navigator: Navigator,
    private eventsService: EventsService,
    private gamesService: GamesService,
    private lobbyStateService: LobbyStateService,
    private scroll: ScrollService,
    private readonly lobbyService: LobbyService
  ) {
    this.showLDInFavTab = toBoolean(this.config.getConfig().FEATURE_LIVE_DEALER_FAVOURITE_TAB) ?? true;
  }

  ngOnInit() {
    this.imagesPath = this.lobbyService.galleryImagePath;
    this.configReload();
    this.userSessionService
      .getCustomerSubscription()
      .then((subscription) => this.subscribeToCustomer(subscription));
    this.updateAuthentication();

    this.subscr.push(this.lobbyStateService.getCurrentKeywordSubject().subscribe((data) => {
      this.filteredCasinoGames = data?.gamesInfo;
      this.selectedItem = data.keyword;
      if (this.isMobileApp && this.filteredCasinoGames) {
        this.mobileGameCounter = 1;
        this.allGamesLoaded = false;
        this.mobileCasinoGames = this.filteredCasinoGames.slice(
          0,
          this.mobileGamesSize
        );
      }
    }));
    if (this.isMobileApp) {
      this.subscr.push(this.scroll.getScrollPosition().subscribe((element) => {
        if (element.detail.scrollTop > 300 * this.mobileGameCounter && !this.allGamesLoaded) {
          this.updateMobileCasinoGames();
          this.mobileGameCounter++;
        }
      }));
    }
  }

  ngOnDestroy(): void {
    this.subscr.forEach(s => s.unsubscribe());
  }

  configReload() {
    this.subscr.push(this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        setTimeout(() => {
          this.imagesPath = this.lobbyService.galleryImagePath;
        }, 500);
      })
    }));
  }

  subscribeToCustomer(subscription) {
    this.subscr.push(subscription.subscribe(() => {
      this.updateAuthentication();
      let demoModeEnabled = false; //this.config.getConfig()["DEMO_MODE_ENABLED"] == "1" ? true : false;
      let demoLoggedOutEnabled = false; //this.config.getConfig()["DEMO_LOGOUT_ENABLED"] == "1" ? true : false;

      //if the master switch DEMO_MODE_ENABLED is false turn all demo mode off
      if (!demoModeEnabled) {
        this.isDemoEnabled = false;
      }
      //if the DEMO_LOGOUT_ENABLED is false that means the player cant play demo mode while logged out. So next we check if the player is logged out and if so turn off demo mode
      else if (!demoLoggedOutEnabled && !this.isAuthenticated) {
        this.isDemoEnabled = false;
      }
      //otherwise demo is on son!
      else {
        this.isDemoEnabled = true;
      }
    }));
  }

  updateAuthentication() {
    this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });
  }

  doInfinite(e) {
    setTimeout(() => {
      this.increasePageSize();
      e.target.complete();
    }, 500);
  }

  increasePageSize() {
    this.pageSize = this.pageSize + this.pageSizeSet;
  }

  launchCasinoGame(gameData) {
    if (!this.isAuthenticated) {
      // save the gameData for later launch
      //this.LobbyService.setWaitingGameData(gameData);
      return this.openLoginModal(gameData);
    }

    return this.gameHubControllerService.launchCasinoGame(gameData);
  }

  launchCasinoGameDemo(gameData) {
    // this.gameHubControllerService.launchCasinoGameDemo(gameData);
  }

  openLoginModal(gameData) {
    this.lobbyService.setWaitingGameData(gameData);
    return this.navigator.navigateTo("LoginComponent");
  }

  public onInfo(gamedata: any) {
    return this.navigator.navigateTo('GameDetailsComponent', { multipleModals: false }, { gamedata });
  }

  public checkForExternalLinks(url: string): any {
    const externalLinks = this.config.getExternalLinks().payload;
    const filteredExternalLink = externalLinks.filter(
      (link) => link.url == url
    )[0];
    return filteredExternalLink;
  }

  public getWPPageStub(name: string): string {
    const onlyAlphaNumeric = onlyAphaNumeric(name);
    const lowerCaseName = onlyAlphaNumeric.toLowerCase();
    const urlStub = spaceToHyphen(lowerCaseName);
    return urlStub;
  }

  public updateWpContent(link: any, page: string): any {
    const gameInfoErrorPage = this.config.getConfig().WP_GAME_INFO_ERROR_PAGE ?? "gameinfo_default";
    if (isUndefined(link) && !link) return this.webcontentService.updateExternalLink(gameInfoErrorPage);
    return this.webcontentService.updateExternalLink(page);
  }

  isFavourite(game_id) {
    if (!this.isAuthenticated) return false;
    return this.gamesService.isFavourite(game_id);
  }

  updateMobileCasinoGames() {
    if (!this.filteredCasinoGames) return;
    if (this.mobileCasinoGames.length < this.filteredCasinoGames.length) {
      this.mobileGamesSize = this.mobileGamesSize + 20;
      this.mobileCasinoGames = this.filteredCasinoGames.slice(
        0,
        this.mobileGamesSize
      );
    } else {
      this.mobileGamesSize = 20;
      this.allGamesLoaded = true;
    }
  }

  makeFavourite(gamedata) {
    if (!this.isAuthenticated) {
      this.navigator.navigateTo("LoginComponent");
      return;
    }

    this.gamesService.addFavouritesAndRecreate(gamedata);
    return;
  }

  makeUnFavourite(game_id) {
    if (!this.isAuthenticated) {
      this.navigator.navigateTo("LoginComponent");
      return;
    }

    this.gamesService.removeFavouritesAndRecreate(game_id);

    return;
  }

  getContentFromJSON(json) {
    if (!json) return;
    return JSON.parse(json);
  }
}